import React from "react";

const Research = () => {
  return (
    <>
      <div className="research py-5">
        <div className="container py-lg-5">
          <div className="row">
            <div className="col-lg-10 m-auto">
              <div className="research-content text-center m-auto">
                <p className="research-heading text-uppercase">
                  research and innovation
                </p>
                <p className="research-para">
                  The business produces novel formulations as a result of its
                  research-driven methodology. Rumeno Farmotech always stays on
                  the cutting edge, whether it's boosting fertility, preventing
                  deficiencies, or improving digestion.
                </p>
              </div>
              <div className="row py-lg-5">
                <div className="col-lg-5">
                  <div className="research-col1 text-center">
                    <p className="research-head1">Customer Service</p>
                    <p className="research-para1">
                      Excellent customer service is provided by Rumeno
                      Farmotech, which responds to questions quickly and helps
                      farmers make wise decisions.{" "}
                    </p>
                  </div>
                </div>
                <div className="col-lg-2">
                    <div className="border-col m-auto">

                    </div>
                </div>
                <div className="col-lg-5">
                  <div className="research-col1 text-center">
                    <p className="research-head1">Sustainable Practices</p>
                    <p className="research-para1">
                      It's important to adopt environmentally friendly
                      practices. Sustainability is emphasized in Rumeno
                      Farmotech's manufacturing procedures.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Research;
